<script setup lang="ts">
import { linkExternal } from '@/components/icons/icons.ts';

defineProps<{
  text: string;
  link: string;
}>();
</script>

<template>
  <a :href="link" target="_blank" class="font-weight-bold">
    {{ text }}
    <v-icon class="mb-1 ml-1" :icon="linkExternal" size="small" />
  </a>
</template>
